<template>
  <div class="index-print" v-loading.fullscreen.lock="isPrintLoading">
    <!-- <div class="title">个性化定制</div> -->
      <div class="form-body">
        <!-- <el-scrollbar style="height:calc(90vh - 50px - 44px);overflow-x: hidden;"> -->
        <el-form ref="schemaForm" :rules="rules" :model="formData" label-width="230px" label-position="left">
          <el-form-item label="解读文件类型" prop="fileType">
            <el-checkbox-group v-model="formData.fileType" size="small">
              <el-checkbox :label="item.value" v-for="(item, index) in fileTypeOptions" :key="index">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="选择模型" prop="selectedModels">
            <el-button plain size="small" @click="selectModelBtn">选择模型<i class="el-icon-caret-bottom"></i></el-button>
            <div class="select-model-content">
                <div class="select-model" v-for="(item,index) in formData.selectedModels" :key="index">
                  <div class="ellipsis" :title="item.text">{{item.text}}
                  </div>
                  <div>
                    <i class="el-icon-close" @click="handleDelete(index)"></i>
                  </div>
                </div>
            </div>
          </el-form-item>
          <el-form-item label="解读主体可选范围" prop="entityType">
            <el-row>
              <el-col :span="20">
                <el-radio-group v-model="formData.entityType">
                  <el-radio label="subscribe">仅允许订阅的主体</el-radio>
                  <el-radio label="list">自定义</el-radio>
                </el-radio-group>
              </el-col>
              <el-col :span="4" class="tab-list-button">
                <i :class="'el-icon-edit icon-btn'+(formData.entityType=='list'?' active':' icon-disabled')" @click="formData.entityType=='list' && editBtn()"></i>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="主体名称" v-if="formData.entityType=='list'" style="margin-bottom: 5px">
            <el-row>
              <el-col :span="24">
                <div class="table-list">
                  <el-table
                      ref="filterTable"
                      :data="tableData"
                      height="160"
                      border
                      size="small"
                      :show-header="false"
                      style="width: 100%">
                    <el-table-column
                        prop="name"
                        label=""
                        width="*"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="产品部署方式" prop="deploymentType">
            <el-checkbox-group v-model="formData.deploymentType">
              <el-checkbox :label="item.value" v-for="(item, index) in deploymentOptions" :key="index" :disabled="item.disabled">
                <!-- <span v-if="!item.helpText">{{item.label}}</span> -->
                <span>{{item.label}}</span>
                <el-tooltip v-if="item.helpText" :content="item.helpText" popper-class="poper-blue-bg">
                  <info theme="outline" size="18" :strokeWidth="2"/>
                </el-tooltip>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="开启chatFileDream (实验中)" prop="openChat">
            <el-radio-group v-model="formData.openChat">
              <el-radio :label="item.value" v-for="(item, index) in openChatOptions" :key="index">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="产品名称" prop="name">
            <el-input v-model="formData.name" placeholder="请输入产品名称" size="small"></el-input>
          </el-form-item>
          <!-- <el-row class="tab-list-button"><img class="icon-img icon-btn active" :src="chatGptImg" title="自动生成产品说明" @click="autoCreateDesc"/></el-row>
          <el-form-item label="产品说明" prop="desc">
            <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入产品说明"
                v-model="formData.desc">
            </el-input>
          </el-form-item>
          <el-form-item label="LOGO" prop="logo">
            <el-upload
                class="upload-demo"
                ref="upload"
                :on-remove="handleRemove"
                action=''
                :file-list="logoFileList"
                :on-change="handleUploadChange"
                :multiple="multiple"
                :accept="'.'+fileAllowType.join(',.')"
                :auto-upload="false">
              <el-button slot="trigger" size="small" plain type="primary">选取文件</el-button>
              <div slot="tip" class="el-upload__tip" style="display: inline-block;margin: 0 0 0 20px;">只能上传{{ fileAllowType.join('/') }}文件，且不超过{{ allowFileSize }}M</div>
            </el-upload>
          </el-form-item> -->
        </el-form>
        <!-- </el-scrollbar> -->
      </div>
      <div class="footer-center print-footer">
        <el-button type="primary" plain @click="print()">定制</el-button>
      </div>

      <el-dialog 
        top="10vh"
        :visible.sync="dialogSampleVisible" 
        width="80vw"
        :close-on-click-modal='false' 
        :fullscreen="false"
        append-to-body
      >
      <template #title>
        <span>样本编辑</span>
      </template>
      <template #default>
        <div class='index-print-sample'>
          <el-form  label-width="140px" :model="form" label-position="left">
            <el-form-item label="客户名称">
              <el-autocomplete
                  v-model="form.name"
                  :fetch-suggestions="querySearch"
                  :trigger-on-focus="false"
                  clearable
                  placeholder="请输入公司名称"
                  @select="searchSampleData"
                  @clear="searchSampleData"
              >
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="所属省份">
              <el-select v-model="form.province" placeholder="请选择" clearable @change="searchSampleData">
                <el-option
                    v-for="item in fl004Options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申银万国行业分类">
              <el-select v-model="form.fl001" placeholder="请选择" clearable @change="searchSampleData">
                <el-option
                    v-for="item in fl001Options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证监会行业分类">
              <el-select v-model="form.fl002" placeholder="请选择" clearable @change="searchSampleData">
                <el-option
                    v-for="item in fl002Options"
                    :key="item.code"
                    :label="item.label"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数据样板" class="customer-form">
              <div class="tree-transfer">
                <div  class="tree-transfer-left">
                  <el-card shadow="never" class="custom-card">
                    <div slot="header" class="clearfix">
                      <el-checkbox  v-model="leftChecked" @change="changeSelectLeft">待选样板</el-checkbox>
                    </div>
                    <el-tree
                        ref="treeLeft"
                        :data="dataLeft"
                        show-checkbox
                        node-key="eid"
                        class="custom-tree"
                        check-on-click-node
                        @check-change="handleCheckChange"
                        :props="defaultProps">
                    </el-tree>
                  </el-card>
                </div>
                <div class="tree-transfer-middle">
                </div>
                <div class="tree-transfer-right">
                  <el-card shadow="never" class="custom-card">
                    <div slot="header" class="clearfix">
                      <el-checkbox v-model="rightChecked" @change="changeSelectRight">已选样板</el-checkbox>
                      <span>{{dataRight.length}}</span>
                      <el-button style="float: right;" type="text" class="custom-button"  @click="removeRight">移除</el-button>
                    </div>
                    <el-tree
                        ref="treeRight"
                        :data="dataRight"
                        show-checkbox
                        node-key="eid"
                        class="custom-tree"
                        check-on-click-node
                        :props="defaultProps">
                    </el-tree>
                  </el-card>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template #footer>
        <div class="footer-center">
          <el-button type="primary" plain @click="submitSelectSampleData">确定</el-button>
          <el-button type="info" plain @click="dialogSampleVisible=false">取消</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog 
      top="10vh"
      :visible.sync="dialogPrintSuccessVisible" 
      width="300px"
      :close-on-click-modal='false' 
      :fullscreen="false"
      @close="_handlerPrintSuccessClose"
      append-to-body
    >
      <template #title>
        <span>定制成功</span>
      </template>
      <template #default>
        <div style="padding-bottom: 20px;">
          定制成功，请到您的<el-link class="link-align" type="primary" :href="printTypeLink" target="_blank">{{printTypeName}}</el-link>查看
        </div>
      </template>
    </el-dialog>

    <dialogSelectModel @selectValue="selectValue"></dialogSelectModel>
  </div>
</template>

<script>
import apiAxios from "@/config/apiAxios";

import dialogSelectModel from "@/components/common/dialogSelectModel"
import { Info } from "@icon-park/vue";


export default {
  name: "print",
  components:{dialogSelectModel, Info},
  props: {
    eid: {
      type: String
    }
  },
  data() {
    return {
      printTitle: "产品定制 - 小智解读",
      isPrintLoading: false,
      dialogSampleVisible: false,
      formData: {
        fileType: [],
        entityType: 'subscribe',
        deploymentType: [],
        productTemplate: 'prod_小智解读',
        name: '',
        desc: '',
        logo: '',
        openChat:'关闭',
        selectedModels:[]
      },
      rules: {
        fileType: [
          { type: 'array', required: true, message: '请选择解读文件类型', trigger: 'change' }
        ],
        deploymentType: [
          { type: 'array', required: true, message: '请选择产品部署方式', trigger: 'change' }
        ],
        name: [
          { required: true, message: '产品名称', trigger: 'blur' }
        ]
      },
      form: {
        name: '',
        province: '',
        fl001: '',
        fl002: '',
      },
      fl004Options: [],
      fl001Options: [],
      fl002Options: [],
      sampleLimit: 20,
      samplePage: 1,
      disabledBtn: false,
      dataLeft:[],
      dataRight:[],
      defaultProps: {
        label: 'name'
      },
      leftChecked: false,
      rightChecked: false,
      tableData: [],
      logoFileList: [],
      fileAllowType: ['jpg','jpeg','gif','png'],
      allowFileSize: 2,
      multiple: false,
      newPanPath: 'usys/cache',
      prodName: '小智解读',
      pbcId: 'api000222',
      uploadJsonFileUri: '',

      fileData:{},
      countFilePro: -1,
      fidList:[],

      isNewProduct: true,
      goodSampleTags: [],
      sbomFileFid: '',
      isPrint: false,
      tipText: "暂存",

      fileTypeOptions: [{
        value: 'pdf',
        label: 'pdf'
      }, {
        value: 'docx',
        label: 'docx'
      }, {
        value: 'txt',
        label: 'txt'
      }
      ],
      deploymentOptions: [
        {
        value: 'prod_tpl_szzk',
        label: '数字智库',
        showHelp: false,
        disabled: false
      },  {
        value: 'TencentCloud',
        label: '私有化(腾讯云)',
        helpText: '暂未开放，如有私有化需要，请联系客户经理。',
        showHelp: true,
        disabled: true
      }, {
        value: 'FinancialCloud',
        label: '私有化(金融云)',
        helpText: '暂未开放，如有私有化需要，请联系客户经理。',
        showHelp: true,
        disabled: true
      }, {
        value: 'offline',
        label: '离线',
        helpText: '不支持云端操作，请联系客户经理。',
        showHelp: true,
        disabled: false
      }
      ],
      openChatOptions: [
        {
          value: '关闭',
          label: '关闭'
        },
        {
          value: '开启',
          label: '开启'
        }
      ],

      dialogPrintSuccessVisible: false,
      printTypeLink: config.zkWebUrl,
      printTypeName: '数字智库',

      // chatGptImg: require('../../assets/img/common/chatgpt.png'),
      userId: sessionStorage.getItem( "USER_ID" ) || '',
      userInfo: JSON.parse(sessionStorage.getItem( "USER_INFO" ))
    };
  },
  created() {
    this.getFLOptions()
    this.getDataSample()

    // window.addEventListener(
    //     "message",
    //     (event) => {
    //       //监听来自小智解读的数据
    //       if( event.data.key == 'select.model.datas' ){
    //         let modelObj = event.data.value || {};
    //         let keys = Object.keys(modelObj);
    //         let models = [];
    //         keys.forEach(item => {
    //           modelObj[item].fid = modelObj[item].id;
    //           models.push(modelObj[item]);
    //         })
    //         this.formData.selectedModels = models;
    //       }
    //     }
    // );
  },
  mounted() {
  },
  methods: {
    //定制
    print() {
      this.isPrint = true;
      this.tipText = "定制";
      this.saveDataFun();
    },

    //处理创建文件的数据结构
    saveDataFun(){
      const _this = this
      this.$refs['schemaForm'].validate((valid) => {
        if(_this.formData.selectedModels.length <= 0){
          _this.$message.error('选择模型不能为空！');
          return ;
        }
        if (valid) {
          debugger
          _this.isPrintLoading = true;
          let fileTypeArr = _this.formData.fileType.map(item => '.' + item);
          let createFileObj = {
            "name": _this.formData.name,
            "openChat": _this.formData.openChat,
            "logo": _this.formData.logo,
            "desc": _this.formData.desc,
            "productTemplate": [_this.formData.productTemplate],
            "input": {
              "file_type": fileTypeArr,
              "entity": {
                "type": _this.formData.entityType,
                "samples": []
              }
            },
            "processor" : [],
            "deployment" : [],
            "selectedModels": _this.formData.selectedModels,
          }
          if( _this.formData.entityType == 'subscribe' && this.eid )
            createFileObj.eids  = [this.eid];
          if(_this.formData.entityType === 'list' && _this.tableData) {
            _this.tableData.forEach((item)=>{
              createFileObj.input.entity.samples.push({"eid":item.eid, "fullName":item.name})
            })
          }
          if (_this.formData.deploymentType) {
            _this.formData.deploymentType.forEach((item)=>{
              createFileObj.deployment.push({
                type: item,
                config: {}
              })
            })
          }
          _this.fileData = createFileObj;

          //直接传数据给后台处理
          apiAxios.apmASyncPost(this.pbcId, createFileObj,{},(res) => {
            if (res.code == 200) {
              this.getApmTask(res.data.taskId)
              
            } else {
              _that.$message.error(`${this.tipText}失败！`);
              _that.isPrintLoading = false;
            }
          });
          return ;
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取异步任务查询
    getApmTask(taskId) {
      apiAxios.apmAsyncResult(taskId, {}, _r => {
          if (_r.data?.taskStatus == 1) {
              window.setTimeout(() => this.getApmTask(taskId), 1000);
          } else if (_r.data?.taskStatus == 11 && _r?.data?.taskResponse) {
              this.isdebug = false;
              let _response = JSON.parse(_r.data.taskResponse);
              if (_response?.code == '200' && _response?.data?.result?.code == '200') {
                  this.$message.success('定制成功！');
                  sessionStorage.removeItem('GOODS_SELECT_JSON_VAL');
                  this.isPrintLoading = false;
                  this.$emit("closePrintDialog");
                  this.isPrint = false;

                  this.dialogPrintSuccessVisible = true;
                  
              } else {
                  this.$message.error('定制失败！' );
                  this.isPrintLoading = false;
              }
          } else {
              this.$message.error('定制失败！' );
              this.isPrintLoading = false;
          }
      })
    },

    editBtn() {
      this.dataRight = this.deepClone(this.tableData)
      this.dialogSampleVisible = true
      this.form.name = ''
      this.form.province = ''
      this.form.fl001 = ''
      this.form.fl002 = ''
      this.searchSampleData()
      let _that = this
      this.$nextTick(() => {
        document.querySelector('.custom-tree').addEventListener('scroll',this.setTreeLoadMore, true)
      });
    },
    /**
     * 输入框辅助提示
     * @param queryString
     * @param cb
     */
    querySearch( queryStr, cb, res ) {
      apiAxios.agentGet( `${config.serverUrl}/cmbs/v1/jump/thdb/lexicon/organization?filter=matchesPattern('full_text','.*${queryStr}.*')&limit=20`, {}, _r => {
        if( cb ){
          let restaurants = [];
          if (_r.code == 200) {
            if (_r.data) {
              _r.data.forEach(_d => {
                restaurants.push({
                  value: _d.fullName,
                  text: _d.fullName
                })
              })
            }
          }
          setTimeout(() => {
            cb( restaurants );
          }, 300 * Math.random());
        }else{
          //  this.options  = _r?.data;
        }
        if( res )
          res( _r?.data.records );
      } )
    },
    getFLOptions() {
      let _that = this
      let params = {
        "fileContent":[
        ]
      }
      apiAxios.apmAbilityPost("api000175", params, {}, _r => {
        if (_r.code == 200) {
          _that.fl004Options = _r.data.FL00000004.children
          _that.fl001Options = _r.data.FL00000001.children
          _that.fl002Options = _r.data.FL00000002.children
        }
      });
    },
    /**
     * 获取数据样板
     */
    getDataSample() {
      let _that = this
      let params = {
        "limit": this.sampleLimit,
        "skip": (this.samplePage - 1)*this.sampleLimit,
        "tags": []
      }
      // "tags":["证监会一级行业名称_房地产业","所属城市编码_370300"]
      if(this.form.province) {
        params.tags.push("所属省份编码_" + this.form.province)
      }
      if(this.form.fl001) {
        params.tags.push("申万行业分类一级编码_" + this.form.fl001)
      }
      if(this.form.fl002) {
        params.tags.push("证监会一级行业编码_" + this.form.fl002)
      }
      if(this.form.name) {
        params.tags.push("机构名称_" + this.form.name)
      }

      apiAxios.apmAbilityPost("api000174", params, {}, _r => {
        if (_r.code == 200) {
          if(_r.data.records) {
            for(let k in _r.data.records) {
              let item = {
                eid: _r.data.records[k].eid,
                name: _that.getCompanyName(_r.data.records[k].tags),
                disabled: _that.hasCheckCompanyName(_r.data.records[k].eid),
                checked: _that.hasCheckCompanyName(_r.data.records[k].eid),
              }
              _that.dataLeft.push(item)
            }
            _that.leftChecked = false
          }
          if (_r.data.records.length < _that.sampleLimit) {
            _that.disabledBtn = true
          } else {
            _that.disabledBtn = false
          }
        }
      });
    },
    submitSelectSampleData() {
      this.tableData = this.deepClone(this.dataRight)
      this.dialogSampleVisible = false
    },
    /**
     * 左侧待选样本重新获取
     */
    searchSampleData() {
      this.samplePage = 1
      this.dataLeft = []
      this.getDataSample()
    },
    /**
     * 左侧待选样本翻页
     */
    pageMore() {
      this.samplePage++
      this.getDataSample()
    },

    getCompanyName(tags) {
      let str = ''
      for(let k in tags) {
        if(k.startsWith('机构名称_')) {
          str = k.replace('机构名称_', '')
          break
        }
      }
      return str
    },
    hasCheckCompanyName(eid) {
      let item = this.dataRight.find(item=>item.eid == eid)
      return item ? true : false
    },
    /**
     * 右侧全选
     */
    changeSelectRight(val) {
      if (val) {
        this.$refs.treeRight.setCheckedNodes(this.dataRight)
      } else {
        this.$refs.treeRight.setCheckedNodes([])
      }
    },
    /**
     * 左侧全选
     */
    changeSelectLeft(val) {
      if (val) {
        this.$refs.treeLeft.setCheckedNodes(this.dataLeft)
      } else {
        this.$refs.treeLeft.setCheckedNodes([])
      }
    },
    /**
     * 添加到右侧
     */
    addToRight(){
      // 获取所有选中的项
      let checkList = this.$refs.treeLeft.getCheckedNodes()
      if(checkList.length){
        for (let i = 0; i < checkList.length; i++) {
          let index = this.dataRight.findIndex(item=>item.eid == checkList[i].eid)
          if(index < 0) {
            this.dataRight.push(this.deepClone(checkList[i]))
          }
        }
        for(let item of checkList){
          let index = this.dataLeft.findIndex(item1=>{
            return item1.eid == item.eid
          })
          if(index>=0){
            this.dataLeft[index].disabled = true
          }
        }
      }
      this.$refs.treeLeft.setCheckedNodes([])
      this.leftChecked = false
      this.rightChecked = false
    },
    /**
     * 右侧移除
     */
    removeRight() {
      let checkList = this.$refs.treeRight.getCheckedNodes()
      if(checkList.length){
        for(let item of checkList){
          let index1 = this.dataLeft.findIndex(item1=>item1.eid == item.eid)
          if(index1 >= 0) {
            this.dataLeft[index1].disabled = false
            this.dataLeft[index1].checked = false
          }
          let index2 = this.dataRight.findIndex(item2=>item2.eid == item.eid)
          if(index2>=0){
            this.dataRight.splice(index2,1)
          }
        }
        this.rightChecked = false
        this.$refs.treeLeft.setCheckedNodes([])
      }
    },
    /**
     * 深度克隆
     */
    deepClone(source) {
      if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
      }
      const targetObj = source.constructor === Array ? [] : {}
      Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
          targetObj[keys] = this.deepClone(source[keys])
        } else {
          targetObj[keys] = source[keys]
        }
      })
      return targetObj
    },
    setTreeLoadMore(){
      let _that = this
      let scrollDiv = document.querySelector('.custom-tree')
      if (parseInt(scrollDiv.scrollHeight - scrollDiv.scrollTop - 5)<scrollDiv.clientHeight){
        if (!_that.disabledBtn) {
          _that.pageMore()
        }
      }
    },
    handleUploadChange(file, fileList) {
      let _this = this
      const isImg = this.fileAllowType.indexOf(file.name.toLowerCase().substring(file.name.lastIndexOf('.') + 1)) !== -1
      const isLt2M = file.size / 1024 / 1024 < this.allowFileSize;

      if (!isImg) {
        this.$message.error('Logo请选择图片格式的文件!');
        this.logoFileList = []
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传Logo图片大小不能超过 2MB!');
        this.logoFileList = []
        return false
      }
      if(fileList.length > 1) {
        this.$message.error('最多选择一个图片文件!');
        this.logoFileList = [fileList[0]]
        return false
      }
      const reader = new FileReader()
      if (file?.originFileObj) {
        reader.readAsDataURL(file.originFileObj)
      } else {
        reader.readAsDataURL(file.raw)
      }
      reader.addEventListener('load', () => {
        let logoUrl = reader.result
        _this.formData.logo = logoUrl
        _this.$refs['schemaForm'].clearValidate(['logo']);
      })
    },
    handleRemove(file, fileList) {
      this.logoFileList = []
      this.formData.logo = ''
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        let index = this.dataRight.findIndex(item=>item.eid == data.eid)
        if(index < 0) {
          this.dataRight.push(this.deepClone(data))
        }
        data.disabled = true
      }
    },


    handleAddMenu(type){
      this.formData[type].push(
        {
          view_name:"",
          pbcId:""
        }
      )
    },
    handleDeleteMenu(type, index){
      this.formData[type].splice(index, 1);
    },
    //自动生成产品说明  TODO 入参还未正确设置
    autoCreateDesc(){
      this.$message.info("功能建设中......");
      return ;

      let _that = this;
      _that.isPrintLoading = true;
      let params = {
        "model": {
          "id": "gpt-35-turbo",
          "name": "GPT-3.5",
          "maxLength": 12000,
          "tokenLimit": 4000
        },
        "messages": [
          {
            "role": "user",
            "content": `有一个数字化的产品,产品的名字叫${_that.formData.name},我们公司基于多年的顶尖客户监管经验和技术积累,利用人工智能的技术进行开发,适用的业务场景为:${bizScene};支持的数据样本为:${dataSample} ;支持产品服务形态为:${serverType};帮我写一个少于200字的产品资料 总结4个卖点 4个亮点`
          }
        ],
        "temperature": 1
      };
      // sysApi.chatGptApi(params, _r => {
      //   if(_r?.data){
      //     _that.formData.desc = _r.data;
      //     _that.isPrintLoading = false;
      //   }else{
      //     _that.$message.error("获取数据失败");
      //     _that.isPrintLoading = false;
      //   }
      // })
    },
    _handlerPrintSuccessClose(){
      //现在默认智库，如果增加了其他类型的定制，这里需要修改printTypeLink、printTypeName
      this.dialogPrintSuccessVisible = false;
      //发送消息给小智解读
      // window.parent.postMessage({
      //   key: 'print.success',
      //   value: JSON.stringify({actName:'个性化定制',ruleId:'',data:{state:true}})
      // }, config.cmdinfoWebUrl);
    },

    handleDelete(index){
      this.formData.selectedModels.splice(index, 1);
    },

    selectModelBtn(){
      let params = {
        params:{},
        selectedModels: this.formData.selectedModels
      }
      this.$EventBus.$emit("opendialogSelectModel", params);
    },
    selectValue(models){
      this.formData.selectedModels = models || [];
    }
    
  }
}
</script>


<style lang="less" scoped>
.index-print {
  position: relative;

  .form-body {
    max-height: calc(80vh - 20px);
    overflow-y: auto;
    padding: 0 0 70px;

    /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
      color: #f52525;
    }
    /deep/ .el-form-item__label,/deep/ .el-checkbox,/deep/ .el-radio {
      color: #1c1f23;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      color: #3383f6;
      background-color: #3383f6;
    }
    /deep/ .el-radio__input.is-checked .el-radio__inner,/deep/ .el-radio__input.is-indeterminate .el-radio__inner{
      color: #3383f6;
      background-color: #3383f6;
    }
    /deep/ .el-checkbox__label,/deep/ .el-radio__label {
      color: #1c1f23;
    }
    /deep/ .el-radio__inner::after {
      width: 5px;
      height: 5px;
    }
    /deep/ .el-button.el-button--small {
      font-size: 14px; 
    }
    /deep/ .el-button {
      color: rgba(28,31,35,.8);
      i {
        color: #acb2bc;
        margin-left: 10px;
      }
    }
    /deep/ .el-checkbox__input.is-disabled .el-checkbox__inner {
      background-color: #c8cbd2;
      border-color: #94989f;
    }
    /deep/ .el-checkbox__input.is-disabled+span.el-checkbox__label{
      color: #c8cbd2;
    }
    /deep/ .el-tooltip__popper.is-dark {
      background-color: rgb(160, 207, 255);
    }
   .i-icon {
    vertical-align: middle;
   }
   .i-icon:hover {
    color: inherit;
   }
  }

  .title {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
  }
  .form-button {
    text-align: center;
  }
  .el-form-item{
    margin-bottom: 16px;
  }
  /deep/.el-form-item__error{
    padding-top: 2px;
  }
  /deep/.el-form-item__label{
    line-height: 30px;
  }
  /deep/.el-form-item__content{
    line-height: 30px;
  }

  .menu-icon {
    padding-left: 5px;
  }

  .icon-disabled {
    cursor: no-drop;
    color: rgba(0,0,0,.3);
  }
  
  .icon-img {
    width: 50px;
    height: 40px;
    margin-right: -10px;
    float: right;
  }

  .print-footer {
    width: 100%;
    position: absolute;
    bottom: 20px;
    z-index: 1;
  }
}
.tab-list-button {
  text-align: right;
  font-size: 20px;
  .icon-btn {
    vertical-align: middle;
    &.active{
      color: #378fe3;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
  padding: 0 20px;
}
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
  padding: 0 20px;
}

.link-align {
  vertical-align: baseline;
}

.select-model-content {
  display: flex;
  flex-wrap: wrap;
  margin-top:5px;
}
.select-model {
  max-width: 200px;
  display: flex;
  margin-right: 10px;
  font-weight: bold;
  background:rgb(64, 158, 255) ;
  padding: 3px 10px;
  color:#ffffff;
  margin-bottom: 5px;

  i:hover {
    cursor: pointer;
  }
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 5px;
}

.tree-transfer{
  display: flex;
  min-height: 250px;
  .tree-transfer-left{
    // min-width: 330px;
    width: 45%;
  }
  .tree-transfer-middle{
    display: flex;
    justify-content: center;
    align-items: center;
    // min-width: 120px;
    width: 10%;
  }
  .tree-transfer-right{
    // min-width: 330px;
    width: 45%;
  }
}
.custom-card{
  .el-card__header{
    padding: 5px 10px;
    background: #F5F7FA;
  }
  .el-card__body{
    padding: 10px 0;
    .custom-button{
      display: block;
      margin: 5px auto;
    }
  }
}
.custom-tree{
  height:250px;
  overflow-y: scroll;
}

.index-print-sample {
  .el-select,.el-autocomplete {
    display: block;
  }
}

  /deep/ .el-dialog {
    border-radius: 10px;
  }
  /deep/ .el-dialog__header {
    height: 60px;
    line-height: 60px;
    padding: 0 20px;
  }
  /deep/ .el-dialog__title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #303133;
  }
  /deep/ .el-dialog__headerbtn {
    height: 60px;
    line-height: 60px;
    top:0;
    right: 20px;
  }
  /deep/ .el-dialog__body {
    padding: 0 20px;
  }

  .footer-center {
    text-align: center;
      button {
        padding: 12px 30px;
      }
  }

</style>
<style lang="less" scope>
.poper-blue-bg {
  background-color: rgb(160, 207, 255) !important;

  .popper__arrow {
    border-bottom-color: rgb(160, 207, 255) !important;
  }
  .popper__arrow::after {
    border-bottom-color: rgb(160, 207, 255) !important;
  }
}
</style>
